import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";

// Landing page components
import Navbar from "./components/landing/Navbar";
import HeroSection from "./components/landing/HeroSection";
import StyleSection from "./components/landing/StyleSection";
import BrandsSection from "./components/landing/BrandsSection";
import ProductsSection from "./components/landing/ProductsSection";
import BenefitsSection from "./components/landing/BenefitsSection";
import LooksSection from "./components/landing/LooksSection";
import TestimonialsSection from "./components/landing/TestimonialsSection";
import UrgencySection from "./components/landing/UrgencySection";
import FinalCTASection from "./components/landing/FinalCTASection";
import Footer from "./components/landing/Footer";

const LandingPage = () => {
  return (
    <div className="min-h-screen bg-[#EDE7E1]" data-testid="landing-page">
      {/* Navigation */}
      <Navbar />

      {/* Main Content */}
      <main>
        {/* 1. Hero Section */}
        <div id="hero">
          <HeroSection />
        </div>

        {/* 2. Style Section - "El estilo que buscas" */}
        <div id="style">
          <StyleSection />
        </div>

        {/* 3. Brands Section - Trucco & Naelle */}
        <div id="brands">
          <BrandsSection />
        </div>

        {/* 4. Products Section - Productos Estrella */}
        <div id="products">
          <ProductsSection />
        </div>

        {/* 5. Benefits Section */}
        <BenefitsSection />

        {/* 6. Looks Inspiration Section */}
        <div id="looks">
          <LooksSection />
        </div>

        {/* 7. Testimonials Section - Prueba Social */}
        <TestimonialsSection />

        {/* 8. Urgency Section */}
        <UrgencySection />

        {/* 9. Final CTA Section */}
        <FinalCTASection />
      </main>

      {/* Footer */}
      <Footer />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
